var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg-icon',{style:({ fill: _vm.color, width: _vm.width && `${_vm.width}px`, height: _vm.height && `${_vm.height}px` }),attrs:{"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }